module.exports = __webpack_public_path__ + "img/Pse.fb7a4689.png";